import React, { useEffect, useState } from 'react'
import { FaTasks } from 'react-icons/fa';
import axiosAuthInstance from '../../../utils/axios/axiosAuthInstance'
import FollowUp from './FollowUp';
import NotAssignedTasks from '../HRDashboard/Components/NotAssignedTask';
import { getRole } from '../../../utils/cookies/cookies';
import TaskCard from '../HRDashboard/Components/TaskCard';
import FinalSubmitTask from '../AdminDashboard/FinalSubmit';
import CustomModal from '../../../components/common/CustomModal';
import { Link } from 'react-router-dom'

const StaffDashboard = () => {
    const role = getRole()
    const [tasksList, setTaskList] = useState([]);
    const [activeTab, setActiveTab] = useState('todaysTask');
     const [openDueModel, setOpenDueModel] = useState(false)
     const [dueTodayTasks, setDueTodayTasks] = useState([])

    const handleTabChange = (tab) => {
        setActiveTab(tab);
    };
 const handleCloseModal = () => {
    setOpenDueModel(false)
  }
    const fetchData = async () => {
        try {
            const response = await axiosAuthInstance.get('task/list',
                { sortPriority: true, limit: 30 }
            )
            if (response && response.status === 200) {
                setTaskList(response.data?.result?.docs)
            }
        } catch (error) {
            console.log('error', error)
        }
    }
    
      const fetchDueTodayTasks = async () => {
        try {
          const response = await axiosAuthInstance.get('task/due-today')
          if (response.status === 200) {
            setDueTodayTasks(response.data?.result)
            setOpenDueModel(true)
          }
        } catch (error) {
          console.error('Error fetching due tasks', error)
        }
      }

    useEffect(() => {
        fetchData()
        fetchDueTodayTasks()
    }, [])

    return (
        <>  
            <div className='w-full bg-white p-2 flex gap-5'>
                <div
                    className={`border-1 p-2 rounded-lg text-sm text-gray-600 hover:bg-orange-100 ${activeTab === 'todaysTask' ? 'bg-orange-100 text-orange-600' : 'hover:text-orange-600'
                        }`}
                    onClick={() => handleTabChange('todaysTask')}
                >
                    <button>Tasks</button>
                </div>

                <div
                    className={`border-1 p-2 rounded-lg text-sm text-gray-600 hover:bg-orange-100 ${activeTab === 'followUp' ? 'bg-orange-100 text-orange-600' : 'hover:text-orange-600'
                        }`}
                    onClick={() => handleTabChange('followUp')}
                >
                    <button>Follow Up</button>
                </div>

                <div
                    className={`border-1 p-2 rounded-lg text-sm text-gray-600 hover:bg-orange-100 ${activeTab === 'completed' ? 'bg-orange-100 text-orange-600' : 'hover:text-orange-600'
                        }`}
                    onClick={() => handleTabChange('completed')}
                >
                    <button>Final Submit</button>
                </div>
            </div>

            {activeTab === "todaysTask" &&
                <div className="p-6 space-y-6 max-w-7xl mx-auto">
                    <h2 className="text-xl font-semibold mb-4 flex items-center gap-2">
                        <FaTasks className="h-5 w-5" />
                        My Tasks
                    </h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                        <TaskCard tasksList={tasksList} reload={fetchData} />
                    </div>
                </div>
            }

            {activeTab === "followUp" &&
                <div className="max-w-6xl mx-auto p-6 space-y-8">
                    <FollowUp reload={fetchData} />
                </div>
            }

            {activeTab === "completed" &&
                <div className="p-6 space-y-6 max-w-7xl mx-auto">
                    <FinalSubmitTask />
                </div>
            }

            {role === "Team Leader" && <NotAssignedTasks reload={fetchData} />}
             {/* Due Task Modal */}
                  {openDueModel && (
                    <CustomModal handleCloseModal={handleCloseModal}>
                      <div className="p-4 relative">
                        <h5 className='m-2 font-bold text-center'>Tasks Due Today</h5>
                        <div className="flex flex-col items-center justify-between gap-4">
                          <div className="overflow-auto w-full max-h-[300px]">
                            <table className="min-w-full table-auto border-collapse">
                              <thead>
                                <tr>
                                  <th className="border px-4 py-2 text-left">Task Name</th>
                                </tr>
                              </thead>
                              <tbody>
                                {dueTodayTasks.map((task) => (
                                  <tr key={task._id}>
                                    <td className="border px-4 py-2">
                                      <Link to={`task/view/${task._id}`}>{task.name}</Link>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                          <div className="flex gap-4 mt-4">
                            <button
                              onClick={handleCloseModal}
                              className="bg-orange-500 text-white px-4 py-2 rounded"
                            >
                              OK
                            </button>
                          </div>
                        </div>
                      </div>
                    </CustomModal>
                  )}
        </>
    )
}

export default StaffDashboard